import { render, staticRenderFns } from "./ForgotEmailForm.vue?vue&type=template&id=de70a108"
import script from "./ForgotEmailForm.vue?vue&type=script&lang=js"
export * from "./ForgotEmailForm.vue?vue&type=script&lang=js"
import style0 from "./ForgotEmailForm.vue?vue&type=style&index=0&id=de70a108&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports